import { render } from "./CaseInfo.vue?vue&type=template&id=7df7d0a3&scoped=true"
import script from "./CaseInfo.vue?vue&type=script&lang=ts"
export * from "./CaseInfo.vue?vue&type=script&lang=ts"

import "./CaseInfo.vue?vue&type=style&index=0&id=7df7d0a3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7df7d0a3"

export default script